/* eslint-disable react-hooks/exhaustive-deps */
import CancelIcon from "@material-ui/icons/Cancel";
import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import AuthApi from "../../context/AuthApi";
import useDocumentTitle from "../../utils/useDocumentTitle";

import { useTranslation } from "react-i18next";
import { Metric, MetricsWrapper } from "../../components/Metric";
import PageContent from "../../components/PageContent";
import Section from "../../components/Section";
import SectionTitle from "../../components/SectionTitle";
import { Tab, Tabs } from "../../components/Tabs";
import { useCampaign } from "../../context/campaign";
import { DashboardLayout } from "../../layouts/DashboardLayout";
import { getLocalValue } from "../../utils/auth";
import { formattedDateString, localToUTC } from "../../utils/datetime";
import { getQueryVariable } from "../../utils/getQueryParam";
import styles from "./Logs.module.scss";
import { LogsFilterBar } from "./LogsFilterBar";
import { LogsTable } from "./LogsTable";
import { loadFilterState } from "./useLogsFilters";

const STORAGE_KEY = "logsTeam_filterState";

export function LogsTeam(props) {
  const { t } = useTranslation();
  useDocumentTitle(props.title);
  const history = useHistory();
  const Auth = useContext(AuthApi);
  const { selectedCampaign } = useCampaign();
  const [id, setId] = useState(getQueryVariable("id"));
  const uid = getLocalValue("uid");
  const userRole = getLocalValue("u_coaching_role_db");
  const [filterValues, setFilterValues] = useState(() => ({
    selectedDateRange: {},
    ...loadFilterState(STORAGE_KEY),
    showFilter: true,
  }));
  const {
    showFilter,
    selectedDateRange,
    selectedSubject,
    selectedType,
    selectedNames,
    selectedStatus,
    searchKey,
  } = filterValues;

  const [filterParam, setFilterParam] = useState("");
  const [metricsFilterParam, setMetricsFilterParam] = useState("");
  const [filterObj, setFilterObj] = useState({});

  const logsTableHeader = [
    {
      name: "session_datetime",
      label: t("logs.sessionStartDate"),
      width: "11%",
    },
    { name: "session_id", label: "Session ID", width: "8%" },
    { name: "duration", label: t("logs.duration"), width: "8%" },
    { name: "type", label: t("logs.type"), width: "8%" },
    { name: "subject", label: t("logs.subjects"), width: "13%" },
    { name: "coachee_name", label: t("logs.name"), width: "11%" },
    { name: "coachee_employee_id", label: t("logs.employeeID"), width: "8%" },
    {
      name: "completion_datetime",
      label: t("logs.completionDate"),
      width: "11%",
    },
    { name: "status", label: t("logs.status"), width: "12%" },
  ];

  useEffect(() => {
    let param = "";
    let metricsParam = "";
    if (showFilter) {
      let filterObject = {
        showFilter: showFilter,
        selectedDateRange: selectedDateRange,
      };
      param += `&session_start_date=${formattedDateString(
        localToUTC(selectedDateRange.startDate)
      )}`;
      param += `&session_end_date=${formattedDateString(
        localToUTC(selectedDateRange.endDate)
      )}`;
      metricsParam += `&start_date=${formattedDateString(
        localToUTC(selectedDateRange.startDate)
      )}`;
      metricsParam += `&end_date=${formattedDateString(
        localToUTC(selectedDateRange.endDate)
      )}`;
      if (selectedSubject) {
        param += `&subject=${selectedSubject.id}&subjectable_type=${selectedSubject.subjectable_type}`;
        metricsParam += `&subject=${selectedSubject.id}&subjectable_type=${selectedSubject.subjectable_type}`;
        filterObject.selectedSubject = selectedSubject;
      }
      if (selectedType) {
        param += `&type=${selectedType.type}`;
        metricsParam += `&type=${selectedType.type}`;
        filterObject.selectedType = selectedType;
      }
      if (selectedNames) {
        param += `&coachee=${selectedNames.uid}`;
        metricsParam += `&coachee=${selectedNames.uid}`;
        filterObject.selectedNames = selectedNames;
      }
      if (selectedStatus) {
        param += `&status=${selectedStatus.value}`;
        metricsParam += `&status=${selectedStatus.value}`;
        filterObject.selectedStatus = selectedStatus;
      }

      setFilterObj(filterObject);
    }
    setFilterParam(param);
    setMetricsFilterParam(metricsParam);
  }, [
    selectedSubject,
    selectedType,
    selectedNames,
    selectedStatus,
    selectedDateRange,
    showFilter,
  ]);

  return (
    <DashboardLayout>
      <div className={styles.pageWrapper}>
        <PageContent>
          <Section>
            <SectionTitle>{t("leftNavigation.logs")}</SectionTitle>
            {Auth.isCampaignCoord && (
              <Tabs>
                <Tab
                  label={"campaign"}
                  tabName={t("tabs.campaign")}
                  linkTo={"/logs/campaign"}
                />
                <Tab
                  label={"team"}
                  tabName={t("tabs.team")}
                  defaultTab={true}
                />
              </Tabs>
            )}
            {Auth.isCoach && !Auth.isCampaignCoord && (
              <Tabs>
                <Tab
                  label={"team"}
                  tabName={t("tabs.team")}
                  defaultTab={true}
                />
                <Tab
                  label={"personal"}
                  tabName={t("tabs.personal")}
                  linkTo={"/logs/personal"}
                />
              </Tabs>
            )}
            {!id && (
              <MetricsWrapper>
                <Metric
                  label={t("logs.totalLogs")}
                  api="getTotalTeamSessionLogs"
                  responseKey="response.data.data"
                  filterParams={`${metricsFilterParam}`}
                  isCampaign={selectedCampaign}
                />
                <Metric
                  label={t("logs.averageDuration")}
                  api="getAverageTeamSessionDuration"
                  responseKey="response.data.data"
                  filterParams={`${metricsFilterParam}`}
                  isCampaign={selectedCampaign}
                />
                <Metric
                  label={t("logs.longestDuration")}
                  api="getLongestTeamSessionDuration"
                  responseKey="response.data.data"
                  filterParams={`${metricsFilterParam}`}
                  isCampaign={selectedCampaign}
                />
                <Metric
                  label={t("logs.shortestDuration")}
                  api="getShortestTeamSessionDuration"
                  responseKey="response.data.data"
                  filterParams={`${metricsFilterParam}`}
                  isCampaign={selectedCampaign}
                />
              </MetricsWrapper>
            )}
            {id && (
              <div className={`${styles.status} ${styles.tag}`}>
                {getQueryVariable("name")}
                <CancelIcon
                  onClick={() => {
                    setId("");
                    history.push("/logs/team");
                  }}
                />
              </div>
            )}
            <LogsFilterBar
              storageKey={STORAGE_KEY}
              onChange={setFilterValues}
              dateRange
              type
              subject={{
                groupBy: option =>
                  option.subject + " - " + option.functional_unit,
              }}
              coachee={{ placeholder: t("logs.names") }}
              status
            />
            <LogsTable
              getDataFrom={"/api/getTeamSessionLogs"}
              uid={uid}
              coacheeId={id}
              searchKey={searchKey}
              tableHeader={logsTableHeader}
              customParam={`?uid=${uid}&campaign_id=${selectedCampaign}&user_role=${userRole}${filterParam}`}
              filterObj={filterObj}
            />
          </Section>
        </PageContent>
      </div>
    </DashboardLayout>
  );
}
